// @ngInject
function VolumeDiscountsApiService(ResourcesService) {

    var endpoint = 'volumediscounts';

    return {
        getVolumeDiscounts: getVolumeDiscounts,
        getVolumeDiscount: ResourcesService.apiFactory.get(endpoint),
        createVolumeDiscount: ResourcesService.apiFactory.create(endpoint,'VolumeDiscount'),
        updateVolumeDiscount: ResourcesService.apiFactory.update(endpoint,'VolumeDiscount'),
        getQuantityGroups: ResourcesService.apiFactory.get(endpoint + '/quantitygroups')
    };


    function getVolumeDiscounts(page, filter, pageSize, companyId) {

        var params = {};

        if (page && page > 1) {
            params.page = page - 1;
        }

        if (pageSize && pageSize > 0) {
            params.pageSize = pageSize;
        }

        if (!_.isEmpty(filter)) {
            params.searchTerm = filter;
        }

        var args = { params: params};

        return ResourcesService.apiFactory.get(endpoint)(args);
    }

}


angular.module('volumediscounts.api', [])
  .factory('VolumeDiscountsApiService', VolumeDiscountsApiService);
